import { render, staticRenderFns } from "./TextObject.vue?vue&type=template&id=fe023eec&scoped=true&"
import script from "./TextObject.vue?vue&type=script&lang=js&"
export * from "./TextObject.vue?vue&type=script&lang=js&"
import style0 from "./TextObject.vue?vue&type=style&index=0&id=fe023eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe023eec",
  null
  
)

export default component.exports